import { MaxTagSize } from './commonConstants';

export default class TagUtils {
	// Kanji Extensions B-F are allowed, due to technical limitations.
	private static cleanRegex =
		/[\u0000-\u001F\u002C\u003B\u007F\u0081\u008D\u008F\u0090\u009D\u00AD\u00B6\u3040-\u309F\u30A0-\u30FF\uFF65-\uFF9F\u4E00-\u9FFF\u3400-\u4DBF\u3000-\u303F]/g;
	private static delimetrs = /,|;|\t|\r\n/;

	public static tooltipText = localize(
		'Each tag has a 50 character limit.<br>Separate multiple tags by using:<br>- TAB Key<br>- RETURN / ENTER key<br>- Comma or semi-colon<br>Supported characters (unsupported characters are automatically removed):<br>- Letters: a-z, A-Z<br>- Numbers: 0-9<br>- All symbols except: , ; ¶<br>- Spaces'
	);

	public static cleanup(tags: string[]): string[];
	public static cleanup(tags: string): string;

	public static cleanup(tags: string[] | string): string | string[] {
		if (typeof tags === 'string') {
			return tags.replace(this.cleanRegex, '');
		} else if (Array.isArray(tags)) {
			return tags.map(t => t.replace(this.cleanRegex, '')).filter(t => t.length > 0);
		}
	}

	public static split(tags: string): string[] {
		return tags?.split(this.delimetrs);
	}

	public static equals(tag1: string, tag2: string): boolean {
		return tag1?.toLowerCase() === tag2?.toLowerCase();
	}

	public static compare(tag1: string, tag2: string): number {
		tag1 = tag1?.toLocaleLowerCase();
		tag2 = tag2?.toLocaleLowerCase();
		return tag1 === tag2 ? 0 : tag1 > tag2 ? 1 : -1;
	}

	public static includes(tag: string, filter: string): boolean {
		return tag.toLocaleLowerCase().includes(filter.toLocaleLowerCase());
	}

	public static clipLength(tag: string): string {
		return tag.substring(0, MaxTagSize);
	}
}
